import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQueries } from 'react-query';

import type { ApiError } from '~/lib/api';
import type { IApiGetArticleResponseBody } from '../ArticlesApi.types';
import type { IUseArticleQueryValues } from './useArticleQuery';
import { useApi } from '~/lib/api/useApi';
import { articleQueryKeyFactory } from './useArticleQuery';

export const useArticlesQueries = (
  valuesList?: Array<IUseArticleQueryValues>,
  options?: UseQueryOptions<IApiGetArticleResponseBody, ApiError>,
): Array<UseQueryResult<IApiGetArticleResponseBody, ApiError>> => {
  const api = useApi();

  return useQueries(
    valuesList?.map(
      (values) =>
        values && {
          queryKey: articleQueryKeyFactory(values),
          queryFn: values
            ? () => api.articles.get(values.appId, values.articleId)
            : undefined,
          enabled: !!values,
          ...options,
        },
    ) ?? [],
  );
};
